import React from 'react';
import { Eyebrow } from '../primitives';

/** PHLD.ai — The problem they feel. Role-aware, concrete busywork. Navy section. */
export function Problem() {
  const roles = [
    { role: 'Concept & design', pain: 'Designing the concept for a space is a talent. Re-typing the spec for the tenth contractor is not.' },
    { role: 'Project management', pain: 'Assigning the tasks by hand after hours of meetings, when everything was already said and decided. That’s precious time gone, time they could spend optimizing your costs and schedules.' },
    { role: 'Build & site teams', pain: 'Re-formatting the same document for every house, instead of building.' },
    { role: 'Brand & boutique', pain: 'The brand philosophy and boutique design masterpieces, lost in tiring meetings and workshops, and delayed by sheer inefficiency.' },
  ];

  const section: React.CSSProperties = { background: 'var(--surface-ink)', color: 'var(--text-on-ink)' };
  const inner: React.CSSProperties = { maxWidth: 'var(--container)', margin: '0 auto', padding: 'var(--space-10) var(--gutter)' };
  const head: React.CSSProperties = {
    fontWeight: 'var(--weight-extralight)' as any,
    fontSize: 'clamp(2rem, 4vw, 3.25rem)',
    lineHeight: 1.1,
    letterSpacing: 'var(--tracking-display)',
    color: 'var(--blush)',
    margin: 'var(--space-5) 0 0',
    maxWidth: '20ch',
  };
  const grid: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '0',
    marginTop: 'var(--space-9)',
    borderTop: '1px solid var(--border-on-ink)',
  };
  const cell: React.CSSProperties = {
    padding: 'var(--space-7) var(--space-6) var(--space-7) 0',
    borderBottom: '1px solid var(--border-on-ink)',
  };
  const roleLabel: React.CSSProperties = {
    fontSize: 'var(--text-overline)',
    fontWeight: 'var(--weight-medium)' as any,
    letterSpacing: 'var(--tracking-overline)',
    textTransform: 'uppercase',
    color: 'var(--periwinkle)',
  };
  const painText: React.CSSProperties = {
    fontSize: 'var(--text-title)',
    fontWeight: 'var(--weight-light)' as any,
    lineHeight: 'var(--leading-snug)',
    color: 'var(--blush)',
    margin: 'var(--space-3) 0 0',
    maxWidth: '34ch',
  };

  return (
    <section style={section} id="the-work">
      <div style={inner}>
        <Eyebrow onInk>The work</Eyebrow>
        <h2 style={head}>
          Your best team gives too many hours to the repetitive work that eats their purpose: you
          hired them to Create.
        </h2>
        <div style={grid}>
          {roles.map((r, i) => (
            <div
              key={r.role}
              style={{
                ...cell,
                paddingLeft: i % 2 === 1 ? 'var(--space-7)' : 0,
                borderLeft: i % 2 === 1 ? '1px solid var(--border-on-ink)' : 'none',
              }}
            >
              <div style={roleLabel}>{r.role}</div>
              <p style={painText}>{r.pain}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
